'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Product {
  id: string;
  name: string;
}

interface ComparisonTableProps {
  products: Product[];
}

const ComparisonTable = ({ products }: ComparisonTableProps) => {
  const features = [
  { category: 'Core Capabilities', items: [
    { name: 'Real-time Aura Visualization', pro: true, compact: true, research: true },
    { name: 'Chakra Energy Analysis', pro: true, compact: true, research: true },
    { name: 'Organ Energy Mapping', pro: true, compact: false, research: true },
    { name: 'Meridian Assessment', pro: true, compact: false, research: true },
    { name: 'Biofeedback Integration', pro: true, compact: false, research: true }]
  },
  { category: 'Technical Features', items: [
    { name: 'Data Points per Session', pro: '10,000+', compact: '5,000+', research: '25,000+' },
    { name: 'Measurement Accuracy', pro: '±2%', compact: '±3%', research: '±1%' },
    { name: 'Color Spectrum Range', pro: '49 colors', compact: '32 colors', research: '49 colors' },
    { name: 'Session Duration', pro: '3-5 min', compact: '2-3 min', research: '5-10 min' },
    { name: 'Cloud Storage', pro: true, compact: false, research: true }]
  },
  { category: 'Software & Integration', items: [
    { name: 'Multi-language Support', pro: '15+', compact: '8+', research: '15+' },
    { name: 'Report Templates', pro: '25+', compact: '10+', research: '50+' },
    { name: 'API Access', pro: false, compact: false, research: true },
    { name: 'Raw Data Export', pro: false, compact: false, research: true },
    { name: 'Custom Protocol Builder', pro: false, compact: false, research: true }]
  },
  { category: 'Support & Training', items: [
    { name: 'Warranty Period', pro: '3 years', compact: '2 years', research: '5 years' },
    { name: 'Technical Support', pro: '24/7', compact: 'Business hours', research: '24/7 Priority' },
    { name: 'Training Included', pro: 'Standard', compact: 'Basic', research: 'Advanced' },
    { name: 'Software Updates', pro: 'Lifetime', compact: 'Lifetime', research: 'Lifetime' }]
  }];


  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ?
      <Icon data-component-id="src/app/technology-overview/components/ComparisonTable.tsx:49:6" data-component-path="src/app/technology-overview/components/ComparisonTable.tsx" data-component-line="49" data-component-file="ComparisonTable.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CheckCircleIcon%22%2C%22className%22%3A%22text-accent%20mx-auto%22%7D" name="CheckCircleIcon" size={24} className="text-accent mx-auto" variant="solid" /> :

      <Icon data-component-id="src/app/technology-overview/components/ComparisonTable.tsx:51:6" data-component-path="src/app/technology-overview/components/ComparisonTable.tsx" data-component-line="51" data-component-file="ComparisonTable.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XCircleIcon%22%2C%22className%22%3A%22text-text-secondary%2F30%20mx-auto%22%7D" name="XCircleIcon" size={24} className="text-text-secondary/30 mx-auto" />;

    }
    return <span data-component-id="src/app/technology-overview/components/ComparisonTable.tsx:54:11" data-component-path="src/app/technology-overview/components/ComparisonTable.tsx" data-component-line="54" data-component-file="ComparisonTable.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20font-medium%20text-primary%22%7D" className="text-sm font-medium text-primary">{value}</span>;
  };

  return;




















































































};

export default ComparisonTable;